import React from "react";
import Plot from 'react-plotly.js';
import useCheckDataProps from '../../hooks/useCheckDataProps';
import { Alert } from 'react-bootstrap';
import HelperMetiers360 from "../../services/HelpersMetiers360";
import PropTypes from 'prop-types';

const ChronogramComponent = ({ data = [], aggregated, itemLabel, dataValuesLabel, height = "100%" }) => {

    const [proxiedData, isValid] = useCheckDataProps(data || []);

    const getdisplayDate = (timestamp) => {
        const formatedDate = new Date(timestamp);
        return HelperMetiers360.getdisplayDateType(formatedDate, "day");
    }

    const generateGroupedData = (proxiedData, aggregated) => {
        if (aggregated) return null;

        const uniqueIdWeeks = [...new Set(proxiedData.map(item => item.id_week))].sort();
        const xAxis = uniqueIdWeeks.map(id_week => getdisplayDate(id_week));

        const groupedData = proxiedData.reduce((acc, item) => {
            if (!acc[item[itemLabel + "_id"]]) {
                acc[item[itemLabel + "_id"]] = {
                    x: xAxis,
                    y: Array(xAxis.length).fill(0),
                    [itemLabel + "_id"]: item[itemLabel + "_id"],
                    [itemLabel + "_name"]: item[itemLabel + "_name"]
                };
            }
            const weekIndex = xAxis.indexOf(getdisplayDate(item.id_week));
            acc[item[itemLabel + "_id"]].y[weekIndex] = item[dataValuesLabel];
            return acc;
        }, {});

        return groupedData;
    };
    const groupedItems = !aggregated && generateGroupedData(proxiedData, aggregated);

    const traces = !aggregated ?
        Object.values(groupedItems).map(item => ({
            x: item.x,
            y: item.y,
            type: 'scatter',
            mode: 'lines',
            name: item[itemLabel + "_name"],
        }))
        : [{
            x: proxiedData.map((data) => getdisplayDate(data.id_week)),
            y: proxiedData.map((data) => data[dataValuesLabel]),
            type: 'scatter',
            mode: 'lines',
            marker: { color: 'red' },
        }];

    return data?.length > 0 ?
        (isValid ?
            <Plot
                data={traces}
                    layout={{
                        autosize: true,
                        yaxis: {
                            title: {
                                text: 'Nombre total de vues hebdomadaires',
                                font: {
                                    size: 14,
                                    color: '#7f7f7f',
                                },
                                standoff: 60,
                            },
                        },
                        margin: {
                            l: 50,
                            r: 50,
                            b: 100,
                            t: 50,
                            pad: 4,
                        },
                    }}
                    useResizeHandler={true}
                style={{ width: '100%', height, minHeight: '30em' }}
                />
            : <Alert variant="danger">Les données ne correspondent pas</Alert>)
        : <Alert variant="warning">Aucune donnée à afficher</Alert>;
}

ChronogramComponent.propTypes = {
    data: PropTypes.array.isRequired,
    aggregated: PropTypes.bool.isRequired,
    itemLabel: PropTypes.string.isRequired,
    dataValuesLabel: PropTypes.string.isRequired,
    height: PropTypes.string,
}

export default ChronogramComponent;